export default __webpack_public_path__ + "tier-diamond.svg?dd443709bc324e5c953cf602c2ac98a8";